import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "@environment";
import { ConfigService } from "../../config.service";
import { BehaviorSubject, Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Utilities } from "../../../_helpers/utility/utilities";
import { User } from "../../../_models";
import { EditorGeographicArea } from "src/app/_models/user/editorGeographicArea";

@Injectable({
  providedIn: "root",
})
export class UserSearchService {
  private searchResultsSubject: BehaviorSubject<User[]>;
  public searchResults: Observable<User[]>;
  private userListSubject: BehaviorSubject<User[]>;
  private fullUserListSubject: BehaviorSubject<User[]>;
  public fullUserList: Observable<User[]>;
  private selectedUsersSubject: BehaviorSubject<User[]>;
  public selectedUsers: User[];
  public userList: Observable<User[]>;
  private readonly baseUrl = this.environment.userApi.baseUrl;
  private readonly basicSearchUrl =
    this.baseUrl + this.environment.userApi.basicSearch;
  private readonly getUserList = this.baseUrl + this.environment.userApi.getList;
  private readonly advancedSearchUrl =
    this.baseUrl + this.environment.userApi.advancedUserSearch;

  constructor(private http: HttpClient, private environment: ConfigService) {
    this.searchResultsSubject = new BehaviorSubject<User[]>([]);
    this.searchResults = this.searchResultsSubject.asObservable();
    this.userListSubject = new BehaviorSubject<User[]>([]);
    this.fullUserListSubject = new BehaviorSubject<User[]>([]);
    this.fullUserList = this.userListSubject.asObservable();
    this.userList = this.userListSubject.asObservable();
    this.selectedUsersSubject = new BehaviorSubject<User[]>([]);
    this.selectedUsers = [];  
  }

  getList() {
    const url = this.getUserList;
    const userArray = new Array<User>();
    return this.http.get<User[]>(url).pipe(
      map((users) => {
        users.forEach((user) => {
          const userObj = new User(user);
          userArray.push(userObj);
        });
        userArray.sort(this.alphabeticallyDesc());
        console.log("stop");
        this.userListSubject.next(userArray);
      })
    );
  }

  public get users(): User[] {
    return this.userListSubject.value;
  }

  public get fullUsers(): User[] {
    return this.fullUserListSubject.value;
  }

  public resetUsersList(){
    this.userListSubject.next(this.fullUsers);
  }


  public selectUser(user: User) {
    this.selectedUsers.push(user);
    this.initUsers(user);
  }

  public initUsers(user: User) {
    const currentUserList = this.users
      .filter((removeUser) => removeUser.userId !== user.userId)
      .sort(this.alphabeticallyDesc());
    this.userListSubject.next(currentUserList);
  }

  public initRemoveUsers(usersToRemove: User[]) {
    this.users.filter(
      (removeUser) =>
        !!usersToRemove.find((user) => user.userId !== removeUser.userId)
    );
  }

  private alphabeticallyDesc() {
    return (a, b) => {
      if (a.userProfile.firstName < b.userProfile.firstName) {
        return -1;
      }
      if (a.userProfile.firstName > b.userProfile.firstName) {
        return 1;
      }
      return 0;
    };
  }

  private get selUsers(): User[] {
    return this.selectedUsersSubject.value;
  }
  public deselectUser(user: User) {
    // remove selected user from selectedUsers
    // on empty input?
    this.selectedUsers.splice(this.selectedUsers.indexOf(user), 1);
    this.users.push(user);
    this.users.sort(this.alphabeticallyDesc());
    this.userListSubject.next(this.users);
  }

  getSearchResults() {
    return this.searchResults;
  }

  searchAllUsers(limit = 100000, offset = 0) {
    const url = `${this.advancedSearchUrl}?limit=${limit}&offset=${offset}`;
    const body = {
      roleTypes: ["SUPPORT", "GA_EDITOR", "INCIDENT_EDITOR", "ANALYST"],
    };
    const userArray = new Array<User>();
    return this.http
      .post<User[]>(url, body, Utilities.showNotificationHeader(false))
      .pipe(
        take(1)).subscribe(users => {
          users.forEach((user) => {
            const userObj = new User(user);
            userArray.push(userObj);
          });
          userArray.sort(this.alphabeticallyDesc());
          this.userListSubject.next(userArray);
          this.fullUserListSubject.next(userArray);
        })
      ;
  }

  getGaeStaffReport() {
    return this.http.get<EditorGeographicArea[]>(
      `${this.baseUrl}/${this.environment.userApi.gaeStaffReport}`
    );
  }
}
